"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ripple = void 0;
const react_1 = require("react");
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const noop = () => { };
const rippleClass = (0, nano_theme_1.rule)({
    bdrad: '50%',
    h: '100px',
    w: '100px',
    pos: 'absolute',
    transform: 'scale(0)',
    op: 1,
    pointerEvents: 'none',
    '@keyframes decor-ripple': {
        '100%': {
            transform: 'scale(12)',
            op: 0,
        },
    },
});
class RippleImpl extends react_1.Component {
    constructor() {
        super(...arguments);
        this.el = null;
        this.elRipple = null;
        this.startAnimationTimer = null;
        this.clearAnimationTimer = null;
        this.ref = (originalRef) => (el) => {
            this.el = el;
            (originalRef || noop)(el);
        };
        this.refRipple = (el) => {
            this.elRipple = el;
        };
        this.clearTimers = () => {
            if (this.startAnimationTimer) {
                clearTimeout(this.startAnimationTimer);
                this.startAnimationTimer = null;
            }
            if (this.clearAnimationTimer) {
                clearTimeout(this.clearAnimationTimer);
                this.clearAnimationTimer = null;
            }
        };
        this.clearAnimation = () => {
            if (!this.elRipple)
                return;
            this.elRipple.style.removeProperty('animation');
            this.clearAnimationTimer = null;
        };
        this.onMouseDown = (originalMouseDown) => (event) => {
            if (this.props.disabled)
                return;
            if (!this.elRipple || !this.el)
                return;
            const { left, top } = this.el.getBoundingClientRect();
            const posX = left + window.scrollX;
            const posY = top + window.scrollY;
            const elX = event.pageX - posX;
            const elY = event.pageY - posY;
            const style = this.elRipple.style;
            this.clearTimers();
            style.removeProperty('animation');
            style.top = elY - 50 + 'px';
            style.left = elX - 50 + 'px';
            this.startAnimationTimer = setTimeout(() => {
                style.setProperty('animation', `decor-ripple ${this.props.ms}ms linear`);
                this.startAnimationTimer = null;
                this.clearAnimationTimer = setTimeout(this.clearAnimation, this.props.ms);
            }, 35);
            (originalMouseDown || noop)(event);
        };
    }
    componentWillUnmount() {
        this.clearTimers();
        this.clearAnimation();
    }
    render() {
        const { children, color } = this.props;
        const element = react_1.Children.only(children);
        const ripple = (0, react_1.createElement)('div', {
            className: rippleClass,
            style: {
                background: color,
            },
            ref: this.refRipple,
            onAnimationEnd: this.clearAnimation,
        });
        const p = typeof element.props === 'object' ? (element.props ?? {}) : {};
        let style = p.style || {};
        style = Object.assign({}, style, {
            overflow: 'hidden',
            position: 'relative',
        });
        const innerChildren = react_1.Children.toArray(p.children);
        return (0, react_1.cloneElement)(element, {
            ...p,
            style,
            ref: this.ref(p.ref),
            onMouseDown: this.onMouseDown(p.onMouseDown),
        }, ...[ripple, ...innerChildren]);
    }
}
RippleImpl.defaultProps = {
    color: 'rgba(0,0,0,.2)',
    ms: 400,
};
const Ripple = (props) => {
    const styles = (0, context_1.useStyles)();
    const defaultColor = styles.light ? 'rgba(0,0,0,.2)' : 'rgba(255,255,255,.18)';
    return (0, react_1.createElement)(RippleImpl, { ...props, color: props.color ?? defaultColor });
};
exports.Ripple = Ripple;
